export const WAREHOUSE_ORDER_ITEM_STATUS_COMPLETED = 200
export const WAREHOUSE_ORDER_ITEM_STATUS_PENDING = 100
export const WAREHOUSE_ORDER_ITEM_STATUS_IN_PROGRESS = 110
export const WAREHOUSE_ORDER_ITEM_STATUS_REJECTED = 400


export const REJECTION_MESSAGE_NOT_SENT = 'Not Sent';
export const REJECTION_MESSAGE_BY_MISTAKE = 'Created By Mistake';
export const PREDEFINED_REJECTION_MESSAGES = [REJECTION_MESSAGE_NOT_SENT, REJECTION_MESSAGE_BY_MISTAKE];